import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import { InvestorAnnouncements } from "services/cms/models/investorAnnouncements";
import { ResolvedMegaMenuCtaButton, transformCtaButton } from "./headerMegaMenuCTAResolver";
import { InvestorAnnouncementModel } from "models/investorAnnouncementsModel";

export interface ResolvedInvestorAnnouncements {
    heading: string;
    cta: ResolvedMegaMenuCtaButton;
    investorAnnouncements: InvestorAnnouncementModel[];
    codename: string;
    type: ContentTypeCodenames.InvestorAnnouncements;
}

const investorAnnouncementsResolver = (
    data: InvestorAnnouncements
): ResolvedInvestorAnnouncements => {
    return {
        heading: data.elements?.heading.value,
        cta:
            data.elements?.cta.linkedItems[0] &&
            transformCtaButton(data.elements?.cta.linkedItems[0]),
        investorAnnouncements: data.elements.data as InvestorAnnouncementModel[],
        codename: data.system.codename,
        type: ContentTypeCodenames.InvestorAnnouncements,
    };
};

export default investorAnnouncementsResolver;
